import axios from '../../axios'

// 新增专业详情
export const addSchoolProf = (data) => {
    return axios({
        url: '/api/data/wish/school/prof',
        method: 'POST',
        data
    })
}

// 修改专业详情信息
export const editSchoolProf = (data) => {
    return axios({
        url: '/api/data/wish/school/prof',
        method: 'PUT',
        data
    })
}

// 删除专业详情信息
export const deleteSchoolProf = (data) => {
    return axios({
        url: '/api/data/wish/school/prof',
        method: 'DELETE',
        data
    })
}

// 根据信息综合搜索专业详情信息列表
export const searchSchoolProfList = (data) => {
    return axios({
        url: '/api/data/wish/school/prof',
        method: 'GET',
        data
    })
}

// 获取专业详情详情
export const getSchoolProfInfo = (data) => {
    return axios({
        url: '/api/data/wish/school/prof/info',
        method: 'GET',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/SchoolProf.js